export const loginRoute = 'login';
export const inviteSentRoute = 'invite-sent';
export const registerRoute = 'register';
export const reqResetPassRoute = 'request-reset-pass';
export const passwordResetRoute = 'reset/:uid/:token';
export const validateRegistrationRoute = 'self-registration/:uid';
export const invitationAcceptRoute = 'invitation/:token';
export const selectCompanyRoute = 'company';
